import { CommonModule } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalFooterDirective, SidepanelService } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { SidepanelDownloadsComponent } from 'mbs-ui-shared@components/sidepanel-downloads/sidepanel-downloads.component';
import Computer from 'mbs-ui-shared@models/Computer';

@UntilDestroy()
@Component({
  selector: 'agent-update-required-modal',
  templateUrl: './agent-update-required-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class AgentUpdateRequiredModalComponent {
  private i18n = inject(I18NextPipe);
  private sidepanelService = inject(SidepanelService);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public alertType = MbsPopupType.warning;

  public get osName(): string {
    const isMac = Computer.isMac(this.baseModal?.data?.computer);

    return this.i18n.transform(`shared:computers.searchOSType.${isMac ? 'macOS' : 'linux'}`);
  }

  public openDownloadsSidepanel(): void {
    this.sidepanelService.addAndOpenByType(SidepanelDownloadsComponent).pipe(untilDestroyed(this)).subscribe();
    this.baseModal.close();
  }
}
